import React from "react";
import ScreenPanel from "./ScreenPanel";

const SingleScreen = ({ 
  competitionId, 
  config, 
  onConfigChange, 
  onSettingsClick, 
  onSwitchScreenMode,
  routes, 
  t 
}) => {
  return (
    <div className="single-screen">
      <ScreenPanel
        competitionId={competitionId}
        config={config}
        onConfigChange={onConfigChange}
        onSettingsClick={onSettingsClick}
        onSwitchScreenMode={onSwitchScreenMode}
        routes={routes}
        t={t}
        isQuadMode={false}
      />
    </div>
  );
};

export default SingleScreen;